import React from "react";
import { Reveal } from "@/components/Reveal";
import { MANIFESTO } from "@/data/content";

export const Manifesto = () => (
  <section id="approach" data-testid="manifesto-section" className="py-24 md:py-36 bg-navy">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Our Approach</p>
        <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl text-[#F6F4F0] max-w-3xl leading-tight mb-20">
          Four principles. One relentless focus on your growth.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.08}>
            <div className="group border-t border-[#F6F4F0]/12 pt-8">
              <div className="flex items-baseline gap-6">
                <span className="font-heading text-6xl md:text-7xl text-gold/90 leading-none">{m.n}</span>
                <div>
                  <h3 className="font-heading text-3xl text-[#F6F4F0] mb-4 group-hover:text-gold transition-colors duration-300">
                    {m.word}
                  </h3>
                  <p className="text-[#E5E7EB] font-light leading-relaxed max-w-md">{m.text}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
